import {createTheme, Theme, ThemeOptions} from '@material-ui/core';

export default function createZeiterfassungTheme(options: ThemeOptions): Theme {
	return createTheme({
		palette: {
			primary: {
				main: '#131b2e',
			},
			secondary: {
				main: '#009fba',
				contrastText: '#ffffff',
			},
			error: {
				main: '#920000',
				contrastText: '#ffffff',
			},
		},
		...options,
	});
}
